<template>
    <div id="videoRecListContent" class="rec-feed">
        <h1 class="header">推荐视频</h1>
        <div class="list-wrap" id="recId" data-spm="rec-feed">
            <ul class="list" ref="listRef">
                <li v-for="(item, index) in list" :key="index">
                    <a class="item" :href="item.url" target="_blank">
                        <div class="img-box img-do">
                            <div class="cover-layer"></div>
                            <img :src="item.cover && item.cover[0]" alt="">
                            <span v-if="item.total" class="duration">{{ item.total }}</span>
                        </div>
                        <div class="content">
                            <p class="title">{{ item.title }}</p>
                        </div>
                    </a>
                </li>
            </ul>
            <!-- 加载状态 -->
            <div class="loader loading" v-if="isLoading">
                <a href="javascript:void(0)">加载更多</a>
            </div>
            <div class="loader" v-if="isFinished">已经到底了</div>
        </div>
    </div>
</template>

<script>
import { setPicSize } from "@/utils/pic-util"
import Util from "@/_utils/util"
import Str from "@/utils/string"
import { recListApi } from '../request/api'

export default {
    data() {
        return {
            isLoading: false,
            isFinished: false,
            size: 24,
            page: 1,
            list: [],
            preLoadOffset: 200 // 保持与 hot-list 一致
        }
    },
    mounted() {
        this.getData()
        window.addEventListener('scroll', Util.throttle(this.handleScroll, 50), true)
    },
    unmounted() {
        window.removeEventListener('scroll', this.handleScroll, true)
    },
    methods: {
        async getData() {
            try {
                if (this.isLoading || this.isFinished) return
                this.isLoading = true
                const params = {
                    page: this.page++,
                    size: this.size
                }
                let list = await recListApi(params)
                list.forEach((item) => {
                    item = this.formatData(item)
                    this.list.push(item)
                })
                if (list.length < this.size) {
                    this.isFinished = true
                }
                this.$nextTick(() => {
                    sohuSpm?.domDidChange({ target: 'rec-feed' })
                })
                this.isLoading = false
                // 初次请求,前8条传给播放器
                if(this.page == 2) {
                    const recList = this.list.slice(0, 8)
                    window.videoIns.emit('setRecList', recList)
                }
            } catch (error) {
                this.isFinished = true
                this.isLoading = false
            }
        },
        formatData(item) {
            item.title = Str.subString(item.title, 24) // 统一截取逻辑
            const ratio = 2
            const coverWidth = 230 * ratio
            const coverHeight = 128 * ratio
            item.cover && item.cover[0] && (item.cover[0] = setPicSize(item.cover[0], coverWidth, coverHeight))
            return item
        },
        handleScroll() {
            if (this.isLoading || this.isFinished) return
            const listEl = this.$refs.listRef
            const listBottom = listEl.getBoundingClientRect().bottom
            const windowHeight = window.innerHeight
            if (listBottom - windowHeight <= this.preLoadOffset) {
                this.getData()
            }
        }
    }
}
</script>

<style scoped lang="less">
.rec-feed {
    margin-top: 28px !important;
    overflow: hidden;

    .header {
        margin-bottom: 30px;
        font-size: 25px;
        color: #404040;
        font-weight: bold;
    }

    .list {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
        gap: 16px;
    }

    .item {
        display: block;
        text-decoration: none;
        background: #fff;
        border-radius: 3px;
        width: 230px;
        box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);

        &:hover {
            .cover-layer {
                z-index: -1;
            }
            box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
        }
    }

    .img-box {
        position: relative;
        width: 100%;
        height: 128px;
        border-radius: 3px 3px 0 0;
        background: #EEEEEE;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .duration {
            position: absolute;
            right: 8px;
            bottom: 8px;
            padding: 2px 4px;
            background: rgba(0, 0, 0, 0.6);
            color: #fff;
            font-size: 12px;
            border-radius: 2px;
        }
    }

    .content {
        padding: 10px 14px;

        .title {
            font-size: 15px;
            color: #404040;
            line-height: 1.4;
            height: 44px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }

    .loader {
        text-align: center;
        padding: 16px;
        color: #999;

        &.loading {
            cursor: pointer;
            color: #666;
        }
    }
}
</style>
